import GameState from "slotworks/model/game-state";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";
import ICSpinRecord from "integration/revolver/schema/spin-record";
import ICFreespinRecord from "integration/revolver/schema/freespin-record";

// todo refactor
export default class PotsTriggeredDecision extends Decision {
    public evaluate() {
        const icrecord = GameState.getCurrentGame().getCurrentRecord() as ICSpinRecord | ICFreespinRecord;

        if(icrecord.potTriggeredFeatures)
            for(let potAction of icrecord.potTriggeredFeatures) 
                if(potAction && potAction.length > 0) {
                    return Exit.True;
                }

        return Exit.False;
    }
}